export default "__VITE_ASSET__Da3pF8Xw__"